import { combineReducers } from 'redux';
import common from '../common/redux/reducer';
import auth from '../screens/auth/reducer';
import dashboard from '../screens/Dashboard/reducer';
import downloads from '../screens/DownloadChallenges/reducer';
import map from '../map/reducer';
import { LOGOUT_REQUESTED } from '../screens/auth/constants';
import { PERSIST_KEY } from './constants';
import storage from 'redux-persist/lib/storage';
import challenges from '../screens/Challenges/reducer';
import challenge from '../screens/Challenge/reducer';
import segments from '../screens/Segments/reducer';
import analysis from '../screens/Analysis/reducer';
import resources from '../screens/Resources/reducer';
import admin from '../screens/Admin/reducer';
import monitor from '../screens/Monitor/reducer';
import campaigns from '../screens/Campaigns/reducer';
import campaign from '../screens/Campaign/reducer';
import research from '../screens/Research/redux/reducer';
import createChallenge from '../screens/CreateChallenge/redux/reducer';

const appReducer = combineReducers({
    auth,
    dashboard,
    downloads,
    map,
    challenges,
    challenge,
    segments,
    analysis,
    resources,
    admin,
    monitor,
    campaigns,
    campaign,
    research,
    common,
    createChallenge,
});

const rootReducer = (state, action) => {
    const { type } = action;
    if (type === LOGOUT_REQUESTED) {
        storage.removeItem(PERSIST_KEY);

        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
